import Vue from "vue";
import Vuex from "vuex";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);

const state = {
    accountUid: localStorage.getItem("accountUid") || "",
    accountName: localStorage.getItem("accountName") || "",
    userEmail: localStorage.getItem("userEmail") || "",
    userName: localStorage.getItem("userName") || "",
    userRoles: localStorage.getItem("userRoles") || "",
    userToken: localStorage.getItem("userToken") || "",
};

const getters = {
    getToken: state => {
        return state.userToken;
    },
    getAuth: state => {
        return `Bearer ${state.userToken}`;
    },
    isAuthenticated: state => {
        return state.userToken ? true : false;
    }
};

const debug = process.env.NODE_ENV !== "production";

const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    strict: debug
});

export default store;